export enum ERevalidatePeriods {
  NONE = 0,
  TEN_SECONDS = 10,
  ONE_MINUTE = 60,
  TEN_MINUTES = 600,
  ONE_HOUR = 3600,
  FOUR_HOURS = 14400,
  EIGHT_HOURS = 28800,
  ONE_DAY = 86400,
  ONE_WEEK = 604800,
}
